// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"b0459328","455":"4a69aabc","977":"b4095614"}[chunkId] + ".chunk.js";
};